import { IAddPetRequest } from '@/shared/interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const addPet = async (petData: IAddPetRequest) => {
    return await fetchIStatus<string, IAddPetRequest>(
        '/api/pets',
        'POST',
        petData,
    );
};
